<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-container :scrId="scrId" />
				</sf-card>
			</div>
			<div class="sf-col sf-col-20 overflow-auto">
				<table-container :scrId="scrId" />
			</div>
		</div>
	</div>
</template>

<script>
import SearchContainer from './Search/SearchBar.vue';
import TableContainer from './Table/QueueRecordCountTable.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		SearchContainer,
		TableContainer
	}
};
</script>

<style SearchContainer></style>
